/**
 * Text für HTML maskieren. Gilt für Element-Inhalte ebenso wie für Attribute in "…" und '…':
 * Auch Anführungszeichen werden ersetzt, sonst könnte ein Wert in value="…" das Attribut
 * verlassen und eigene Event-Handler mitbringen. Viele Werte stammen aus anderen Schulen
 * (Träger-User arbeiten dort), deshalb überall diese eine Funktion verwenden.
 */
export function esc(s: unknown): string {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
